import axios from 'axios';

/**
 * Axios-Client fuer die Berichte-API (`/api/berichte`).
 *
 * Relative baseURL: nginx leitet `/api/berichte` an den berichte-service.
 * Die Liste antwortet im ApiResponse-Wrapper `{ success, message, data }`;
 * der einzelne Bericht kommt als reines HTML (fuer die iframe-Anzeige).
 */
const berichteApi = axios.create({
  baseURL: '/api/berichte',
  timeout: 30000,
});

const unwrap = (response) => response.data?.data;

// Liste aller Berichte (Metadaten), neueste zuerst.
export const fetchBerichteApi = () => berichteApi.get('').then(unwrap);

// Vollstaendiges HTML eines Berichts (Rohtext fuer die iframe).
export const fetchBerichtHtmlApi = (id) =>
  berichteApi.get(`/${encodeURIComponent(id)}/html`, { responseType: 'text' })
    .then((r) => r.data);

// Stoesst die Erzeugung an (typ = 'eigen' | 'factorlab' | undefined = beide).
export const generiereBerichtApi = (typ) =>
  berichteApi.post('/generieren', null, { params: typ ? { typ } : {} }).then(unwrap);

// Laufstatus/Fortschritt aller Hintergrund-Jobs (fuer die Fortschrittsanzeige).
export const fetchStatusApi = () => berichteApi.get('/status').then(unwrap);

// Metadaten der aktuell hinterlegten factorlab-Strategie.
export const fetchStrategieApi = () => berichteApi.get('/strategie').then(unwrap);

// Stoesst die Validierung + das Einfrieren der Strategie an (Hintergrund, dauert).
export const freezeStrategieApi = () => berichteApi.post('/strategie/freeze').then(unwrap);

export default berichteApi;
